import React from 'react'

import zh_Hant_default from './dictionary/zh_Hant_default.json'
import zh_Hant_user_permission from './dictionary/zh_Hant_user_permission.json'
import zh_Hant_server_response from './dictionary/zh_Hant_server_response.json'

import en_default from './dictionary/en_default.json'
import en_user_permission from './dictionary/en_user_permission.json'
import en_server_response from './dictionary/en_server_response.json'

// Register available language here
// Reference link: https://www.alchemysoftware.com/livedocs/ezscript/Topics/Catalyst/Language.htm
export enum LanguageCode {
  en = 'en',
  zh_Hant = 'zh_Hant',
}

export enum WorkStation {
  user_permission = 'user_permission',
  server_response = 'server_response',
  default = 'default',
}

const availableLanguages = [
  {
    language: LanguageCode.en,
    name: 'English',
    icon: <></>,
  },
  {
    language: LanguageCode.zh_Hant,
    name: '繁體中文',
    icon: <></>,
  },
]

const _dictionary: (
  language: LanguageCode,
  workstation?: WorkStation,
) => (key: string, params?: string[]) => string = (
  language: LanguageCode,
  workstation = WorkStation.default,
) => {
  let dictionary: { [key: string]: string } = {}

  /**
   * @param key string
   * @param params string[]
   * @return string
   */
  const translate: (key: string, params?: string[]) => string = (
    key: string,
    params?: string[],
  ) => {
    let output = dictionary[key] || key
    if (params && typeof params === 'object') {
      params.map((param) => (output = output.replace('%s', param)))
    }
    return output
  }
  switch (language) {
    case LanguageCode.zh_Hant:
      switch (workstation) {
        case WorkStation.user_permission:
          dictionary = zh_Hant_user_permission
          break
        case WorkStation.server_response:
          dictionary = zh_Hant_server_response
          break
        // you may add custom workstation here ...
        case WorkStation.default:
        default:
          dictionary = zh_Hant_default
          break
      }
      break
    case LanguageCode.en:
    default:
      switch (workstation) {
        case WorkStation.user_permission:
          dictionary = en_user_permission
          break
        case WorkStation.server_response:
          dictionary = en_server_response
          break
        // you may add custom workstation here ...
        case WorkStation.default:
        default:
          dictionary = en_default
          break
      }
      break
  }
  return translate
}

export { availableLanguages, _dictionary }
